import { HttpClient } from '../../httpClient'
import { OpalApi } from '../../schema'

type CreateViewColorV3 = OpalApi<'CreateViewColorV3', 201>

export const createViewColor: CreateViewColorV3 = async (args = {}) => {
  const url = new URL('/loupe/v3/view_colors', window.location.origin)

  return HttpClient()
    .post(url.toString(), args.requestBody)
    .then((res) => res.data)
}
